import { InternalImageMultigetQuery } from '@gql/InternalImageMultigetQuery'

export function useInternalImageMultiget(inputIds: () => string[] | None) {
  const { ui } = useApolloWrap2<gen.InternalImageMultigetQuery, gen.InternalImageMultigetQueryVariables>(InternalImageMultigetQuery)({
    ui: (i) => i?.internalImageMultiget,
    vars: () => {
      const ids = inputIds()
      return ids?.length ? { input: ids } : undefined
    },
  })

  const getFullUrl = (imgUrl: string): gen.ImageFragment | undefined => {
    return ui.value?.find((i) => i.key === imgUrl)?.image
  }

  return { getFullUrl }
}
